/* global axios */
import ApiClient from './ApiClient';

class RedhostingMeetAPI extends ApiClient {
  constructor() {
    super('redhosting_meetings', { accountScoped: true });
  }

  createMeeting(conversationId) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/redhosting_meetings`
    );
  }

  closeMeeting(meetingId) {
    return axios.post(`${this.url}/${meetingId}/close`);
  }

  getMeetings(page) {
    return axios.get(this.url, { params: { page } });
  }
}

export default new RedhostingMeetAPI();
